module.exports = "/static/images/BCT - Marvin Icon_F.png";